import { VStack, HStack, Text, Tooltip, Tag, Progress } from '@chakra-ui/react';
import { TaskBlockViewProps, BlockItemViewProps } from '../../../../view';
import { ReportingViewBaseConfig } from '../../../../base';

export function createDocumentTaskView(
    config: ReportingViewBaseConfig & {
        BlockItem: React.FC<BlockItemViewProps>;
    }
): React.FC<TaskBlockViewProps> {
    const { BlockItem } = config;

    return (props) => {
        return (
            <BlockItem {...props.block}>
                <VStack
                    align="start"
                    px={6}
                    py={4}
                    borderWidth={1}
                    borderColor="whiteAlpha.200"
                    borderRadius="lg"
                    w="full"
                    color="whiteAlpha.800"
                    spacing={3}
                >
                    <HStack w="full" justify="space-between" align="start">
                        <VStack align="start" spacing={0}>
                            <Tooltip
                                placement="top"
                                px={2}
                                py={1}
                                bg="gray.50"
                                color="gray.900"
                                shouldWrapChildren={true}
                                label={props.description}
                                isDisabled={!props.description}
                            >
                                <HStack
                                    fontWeight="medium"
                                    color="whiteAlpha.800"
                                    userSelect="none"
                                >
                                    <Text>{props.label}</Text>
                                </HStack>
                            </Tooltip>
                            <HStack>
                                {props.icon?.kind === 'emoji' && (
                                    <Text>{props.icon.text}</Text>
                                )}
                                <Text color="whiteAlpha.500">{props.note}</Text>
                            </HStack>
                        </VStack>
                        <Tag
                            colorScheme={props.status.colorScheme ?? undefined}
                            size="lg"
                        >
                            {props.status.label}
                        </Tag>
                    </HStack>
                    <Progress {...props.progress} w="full" hasStripe={true} />
                </VStack>
            </BlockItem>
        );
    };
}
